const InitialAggressor = {
    protectionType: null,
    processNumber: null,
    dtExpiration: null,
    name: null,
    educationId: null,
    nationality: null,
    familyConnectionId: null,
    violenceTypes: [],
    restrictions: [],
    attachId: null,
    description: null,
    addresses: [],
    vehicles: [],
    cpf: null,
    dtExpedition: null,
    socialName: null,
    livesWithProtected: false,
    firearmUseHistory: false,
    arrestWarrant: false,
    dtBirth: null,
    cityBirth: null,
    imgScr: undefined,
    file: undefined,
    education: null,
    familyConnection: null,
    hasNoExpiration: false,
    minDistance: null,
    criminalCourt: null,
    reflectiveGroup: false,
    subpoena: null,
};

export default InitialAggressor;